import { DOCUMENT } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { AppLanguage, switchLanguage } from '@core/i18n/i18n.config';
import { ThemeService } from '@core/theme/theme.service';
import { LOCAL_STORAGE } from '@core/storage/storage.tokens';
import { LOCAL_KEYS } from '@core/storage/storage.keys';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <header class="topbar">
      <div class="topbar-spacer"></div>
      <button class="topbar-btn" (click)="toggleLanguage()">
        {{ currentLang() === 'ar-SA' ? 'EN' : 'AR' }}
      </button>
      <button class="topbar-btn" (click)="toggleTheme()">
        <mat-icon [fontSet]="themeIcon().fontSet" [fontIcon]="themeIcon().fontIcon"></mat-icon>
      </button>
    </header>
  `,
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  private translate = inject(TranslateService);
  private theme = inject(ThemeService);
  private doc = inject(DOCUMENT);
  private storage = inject(LOCAL_STORAGE);
  private directionality = inject(Directionality);

  currentLang = this.storage.watch(LOCAL_KEYS.language);

  themeIcon = computed(() =>
    this.theme.theme() === 'dark'
      ? { fontSet: 'uicon-rr', fontIcon: 'fi-rr-sun' }
      : { fontSet: 'uicon-rr', fontIcon: 'fi-rr-moon' },
  );

  toggleLanguage(): void {
    const next: AppLanguage = this.currentLang() === 'ar-SA' ? 'en-US' : 'ar-SA';
    switchLanguage(this.translate, this.doc, this.storage, this.directionality, next);
    // currentLang updates automatically via the watch() signal
  }

  toggleTheme(): void {
    this.theme.toggle();
  }
}
